import React from "react"
import { useTranslation } from "react-i18next"

import { APIStatus } from "shared/ui/api-status/APIStatus"
import { Hint } from "shared/ui/hint/Hint"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface ProductConfiguratorStatusProps {
  productType: string
  isConfigurable?: boolean
  isConfigurationModelFaulty?: boolean
  isConfigurationServiceAvailable?: boolean
  isConfigurationWip?: boolean
  className?: string
}

export const ProductConfiguratorStatus = React.memo(
  ({
    productType,
    isConfigurable,
    isConfigurationModelFaulty,
    isConfigurationServiceAvailable,
    isConfigurationWip,
    className
  }: ProductConfiguratorStatusProps) => {
    const { t } = useTranslation()

    if (!isConfigurationServiceAvailable) {
      return (
        <APIStatus
          unavailableMessage={t("Product.Configuration.ServiceUnavailable")}
          isUnavailable
        />
      )
    }
    if (isConfigurationModelFaulty) {
      return (
        <APIStatus
          className={className}
          unavailableMessage={t("Product.Configuration.ModelFaulty", {
            productType
          })}
          isUnavailable
        />
      )
    }
    if (isConfigurable === false) {
      return (
        <Hint.Root variant="default" className="hint--banner">
          <Hint.Icon name={IconName.INFO} />
          <Hint.Content>
            <Hint.Text>
              {t("Product.Configuration.UnavailableForProduct", {
                productType
              })}
            </Hint.Text>
          </Hint.Content>
        </Hint.Root>
      )
    }
    if (isConfigurationWip) {
      return (
        <Hint.Root variant="default" className="hint--banner">
          <Hint.Icon name={IconName.INFO} />
          <Hint.Content>
            <Hint.Text>
              {t("Product.Configuration.WipProduct", { productType })}
            </Hint.Text>
          </Hint.Content>
        </Hint.Root>
      )
    }
    return null
  }
)
